import options from './chart-contact-agg.component';

export default {
    selector: 'dtChartContactAgg',
    options
};
